<!-- 
  name: WindShied
  description: 风控组件
  author: dhx
  date: 2024-02-29
 -->
<script>
import useApi from "@/api/useApi.js";

async function queryRiskControl() {
  await useApi().queryRiskControl({ order_id: this.orderId });
  this.$emit("refresh"); // 刷新页面
}

const options = {
  name: "WindShied",
  props: {
    orderId: {
      type: String,
      default: ""
    },
    riskInfo: {
      type: String,
      default: ""
    }
  },
  methods: { queryRiskControl }
};

const wrapperStyle = {
  width: "100%",
  height: "200px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
};

const inLineStyle = {
  flexDirection: "row"
};

const render = function(createEl) {
  if (!this.riskInfo) {
    return createEl(
      "div",
      {
        class: options.name,
        style: wrapperStyle
      },
      [
        createEl("h1", {}, "还未查询风遁信息"),
        createEl(
          "el-button",
          {
            type: "primary",
            on: { click: this.queryRiskControl }
          },
          "查询风遁信息"
        )
      ]
    );
  } else {
    return createEl("div", { style: {...wrapperStyle,...inLineStyle} }, [
      createEl("h2", {}, "查询结果："),
      createEl("h2", { style: { color: "red" } }, this.riskInfo)
    ]);
  }
};

export default { ...options, render };
</script>



// WEBPACK FOOTER //
// src/views/fengkong/operation/windShied.vue